import { APICall, IUser } from '../../types';

export enum StudentUserActionTypes {
  CLEAR_USERS = '@@studentUsers/CLEAR_USERS',
  GET_STUDENT_USER = '@@studentUsers/GET_STUDENT_USER',
  GET_STUDENT_USER_FAILURE = '@@studentUsers/GET_STUDENT_USER_FAILURE',
  GET_STUDENT_USER_SUCCESS = '@@studentUsers/GET_STUDENT_USER_SUCCESS',
  RESET_USER = '@@studentUsers/RESET_USER',
  REINVITE_USER = '@@studentUsers/REINVITE_USER',
  RESET_USER_SUCCESS = '@@studentUsers/RESET_USER_SUCCESS',
  REINVITE_USER_SUCCESS = '@@studentUsers/REINVITE_USER_SUCCESS',
  RESET_USER_FAILURE = '@@studentUsers/RESET_USER_FAILURE',
  REINVITE_USER_FAILURE = '@@studentUsers/REINVITE_USER_FAILURE',
  RESET_STUDENT_MFA_REQUEST = '@@studentUsers/RESET_STUDENT_MFA_REQUEST',
  RESET_STUDENT_MFA_SUCCESS = '@@studentUsers/RESET_STUDENT_MFA_SUCCESS',
  RESET_STUDENT_MFA_FAILURE = '@@studentUsers/RESET_STUDENT_MFA_FAILURE',
}

export interface IStudentUserState {
  users: IUser[];
  numberOfUsers: number;
  page: number;
  apiCallsInProgress: APICall[];
  error?: string;
  searchQuery: string;
  searchField: string;
}

export enum BulkActionTypeEnum {
  ASSIGN_STAGE,
  ASSIGN_IMMIGRATION_PROVIDER,
  ADD_TAGS,
  REMOVE_TAGS,
  ADD_PARTNERS,
  REMOVE_PARTNERS,
}
